import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = ["href", "data-product-title", "data-product-id"];
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", { class: "jvm_add_to_wishlist_heart" }, null, -1 /* HOISTED */);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", { class: "jvm_add_to_wishlist_text_add" }, "Add to wishlist", -1 /* HOISTED */);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "jvm_add_to_wishlist_text_remove" }, "Remove from wishlist", -1 /* HOISTED */);
const _hoisted_7 = [
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
];
const _hoisted_8 = { class: "taxonomy-product_tags" };
const _hoisted_9 = ["href"];
const _hoisted_10 = { class: "woocommerce-loop-product__content" };
const _hoisted_11 = { class: "woocommerce-loop-product__title" };
const _hoisted_12 = ["href"];
const _hoisted_13 = { class: "woocommerce-loop-product__stock-static" };
const _hoisted_14 = {
    key: 0,
    class: "star-rating"
};
const _hoisted_15 = { class: "price" };
const _hoisted_16 = {
    key: 0,
    class: "price__from"
};
const _hoisted_17 = { "aria-hidden": "true" };
const _hoisted_18 = { class: "woocommerce-Price-amount amount" };
const _hoisted_19 = { class: "sale-percentage" };
const _hoisted_20 = { class: "woocommerce-Price-amount amount" };
const _hoisted_21 = {
    key: 2,
    class: "woocommerce-Price-amount amount"
};
const _hoisted_22 = {
    key: 2,
    class: "woocommerce-Price-amount amount"
};
const _hoisted_23 = {
    key: 0,
    class: "variation-list"
};
const _hoisted_24 = ["title", "onClick"];
const _hoisted_25 = {
    key: 2,
    class: "variation-list__select"
};
const _hoisted_26 = {
    key: 1,
    class: "quantity-input"
};
const _hoisted_27 = ["href", "data-quantity", "data-product_id", "data-product_sku", "aria-label"];
const _hoisted_28 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["catalog__item product", [
                _ctx.sellable ? 'instock' : 'outofstock',
                'product-type-' + _ctx.product.type,
                { sale: _ctx.product.minPrice < _ctx.product.minBasePrice }
            ]])
    }, [
        _createElementVNode("a", {
            href: `${_ctx.host}/${_ctx.productLink}/${_ctx.product.slug}`,
            class: "woocommerce-LoopProduct-link woocommerce-loop-product__link",
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('viewDetails', { product: _ctx.product })))
        }, [
            _createElementVNode("img", {
                src: _ctx.image,
                class: "attachment-woocommerce_thumbnail size-woocommerce_thumbnail",
                alt: _ctx.product.name
            }, null, 8 /* PROPS */, _hoisted_2)
        ], 8 /* PROPS */, _hoisted_1),
        (_ctx.jvmWishListExists)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "jvm_add_to_wishlist add-to-wishlist",
                href: `?add_to_wishlist=${_ctx.product.id}`,
                title: "Add to wishlist",
                rel: "nofollow",
                "data-product-title": _ctx.product.name,
                "data-product-id": _ctx.product.id,
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('addToWishlist', { product: _ctx.product })))
            }, _hoisted_7, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_8, [
            _createCommentVNode("      <a"),
            _createCommentVNode("          v-for=\"(m, index) in modelTags\""),
            _createCommentVNode("          :key=\"'model-' + index\""),
            _createCommentVNode("          class=\"woocommerce-loop-product__tag\""),
            _createCommentVNode("          :href=\"`${host}/model/${m.slug}/`\""),
            _createCommentVNode("          rel=\"tag\""),
            _createCommentVNode("      >"),
            _createCommentVNode("        {{ m.name }}"),
            _createCommentVNode("      </a>"),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (t, index) => {
                return (_openBlock(), _createElementBlock("a", {
                    key: index,
                    class: "woocommerce-loop-product__tag",
                    href: `${_ctx.host}/product-tag/${t.slug}/`,
                    rel: "tag"
                }, _toDisplayString(t.name), 9 /* TEXT, PROPS */, _hoisted_9));
            }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", _hoisted_11, [
                _createElementVNode("a", {
                    href: `${_ctx.host}/${_ctx.productLink}/${_ctx.product.slug}`
                }, _toDisplayString(_ctx.product.name), 9 /* TEXT, PROPS */, _hoisted_12)
            ]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.stockText), 1 /* TEXT */),
            (_ctx.product.averageRating > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratingStarClasses, (ratingClass, i) => {
                        return (_openBlock(), _createElementBlock("i", {
                            key: i,
                            class: _normalizeClass(ratingClass)
                        }, null, 2 /* CLASS */));
                    }), 128 /* KEYED_FRAGMENT */))
                ]))
                : _createCommentVNode("v-if", true),
            _createCommentVNode("    <span"),
            _createCommentVNode("        v-if=\"maxSalePercentage !== '0'\""),
            _createCommentVNode("        class=\"max-sale-percentage\""),
            _createCommentVNode("    >"),
            _createCommentVNode("      -{{ maxSalePercentage }}%"),
            _createCommentVNode("    </span>"),
            _createElementVNode("span", _hoisted_15, [
                (_ctx.product.type === 'external')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.product?.metadata?.button_text || 'At Moma design store'), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                    : (_ctx.sellable)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.product.maxPrice > _ctx.product.minPrice)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('from')) + "  ", 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            (_ctx.product.minPrice < _ctx.product.minBasePrice)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("del", _hoisted_17, [
                                        _createElementVNode("span", _hoisted_18, [
                                            _createElementVNode("bdi", null, _toDisplayString(_ctx.minBasePrice), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _createElementVNode("ins", null, [
                                        _createElementVNode("span", _hoisted_19, " -" + _toDisplayString(_ctx.minPriceSalePercentage) + "% ", 1 /* TEXT */),
                                        _createElementVNode("span", _hoisted_20, [
                                            _createElementVNode("bdi", null, _toDisplayString(_ctx.minPrice), 1 /* TEXT */),
                                            _createCommentVNode("<small class=\"woocommerce-price-suffix\">EX TAX</small>")
                                        ])
                                    ])
                                ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                    _createElementVNode("bdi", null, _toDisplayString(_ctx.minPrice), 1 /* TEXT */),
                                    _createCommentVNode("<small class=\"woocommerce-price-suffix\">EX TAX</small>")
                                ]))
                        ], 64 /* STABLE_FRAGMENT */))
                        : (_ctx.product.stockStatus === 'outofstock')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                _createElementVNode("small", null, _toDisplayString(_ctx.$t('outOfStock')), 1 /* TEXT */)
                            ]))
                            : _createCommentVNode("v-if", true)
            ]),
            (_ctx.showAddToCartBtn && _ctx.sellable && _ctx.isAccessoriesCategory)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.product.type === 'variable' &&
                        _ctx.product.catalogData?.variations &&
                        _ctx.categorySlug !== 'bracelets')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.catalogData.variations.products, (v) => {
                                return (_openBlock(), _createElementBlock("span", {
                                    key: v.id,
                                    title: v.name,
                                    class: _normalizeClass(["variation-list__item", {
                                            'variation-list__item--selected': v.id.toString() === _ctx.selectedId,
                                            'variation-list__item--outofstock': v.stockStatus === 'outofstock',
                                        }]),
                                    onClick: () => {
                                        if (_ctx.sellable)
                                            _ctx.selectedId = v.id.toString();
                                    }
                                }, [
                                    (_ctx.product.catalogData.variations.type === 'image')
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "variation-list__image",
                                            style: _normalizeStyle({
                                                'background-image': `url(${v.data.url})`,
                                            })
                                        }, null, 4 /* STYLE */))
                                        : (_ctx.product.catalogData.variations.type === 'color')
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                class: "variation-list__color",
                                                style: _normalizeStyle({ 'background-color': v.data })
                                            }, null, 4 /* STYLE */))
                                            : (_ctx.product.catalogData.variations.type === 'select')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(v.data), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                ], 10 /* CLASS, PROPS */, _hoisted_24));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : _createCommentVNode("v-if", true),
                    (_ctx.showQuantityInput)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("span", {
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.increaseQuantity(-1)))
                            }, "-"),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.quantity) = $event)),
                                type: "number",
                                min: "1"
                            }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, _ctx.quantity]
                            ]),
                            _createElementVNode("span", {
                                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.increaseQuantity(1)))
                            }, "+")
                        ]))
                        : _createCommentVNode("v-if", true),
                    (_ctx.product.type !== 'variable' ||
                        (_ctx.product.type === 'variable' &&
                            _ctx.product.catalogData?.variations &&
                            _ctx.product.catalogData.variations.products.length > 0))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: `?add-to-cart=${_ctx.selectedId}`,
                            "data-quantity": _ctx.quantity,
                            class: "button product_type_simple add_to_cart_button ajax_add_to_cart",
                            "data-product_id": _ctx.selectedId,
                            "data-product_sku": _ctx.product.sku,
                            "aria-label": _ctx.$t('addProductToCart', [_ctx.product.name]),
                            onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.$emit('addToCart', { product: _ctx.product, selectedId: _ctx.selectedId, quantity: _ctx.quantity })))
                        }, _toDisplayString(_ctx.$t('addToCart')), 9 /* TEXT, PROPS */, _hoisted_27))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 3,
                            href: `${_ctx.host}/${_ctx.productLink}/${_ctx.product.slug}`,
                            class: "button",
                            onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.$emit('viewDetails', { product: _ctx.product })))
                        }, _toDisplayString(_ctx.$t('showProduct')), 9 /* TEXT, PROPS */, _hoisted_28))
                ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
        ])
    ], 2 /* CLASS */));
}
